import React from 'react';
import PropTypes from 'prop-types';
import { CallbackComponent } from 'redux-oidc';

import LandingPage from '../../components/PageStructure/LandingPage/LandingPage';

import globals from '../../globals/communityGlobals';

import { userManager } from '../../utils/userManager';

const locale = globals.getArea('accountLogin');

class Callback extends React.Component {
  successCallback = user => {
    localStorage.setItem('access_token', user.access_token);
    this.props.login(user.access_token);
  };

  errorCallback = error => {
    userManager.removeUser();
    localStorage.setItem('access_token', null);
    this.props.error(error);
  };

  render() {
    return (
      <CallbackComponent
        userManager={userManager}
        successCallback={this.successCallback}
        errorCallback={this.errorCallback}
      >
        <LandingPage>
          <h1>{locale.getMsg('login')}</h1>
          <div>{locale.getMsg('loading')}</div>
        </LandingPage>
      </CallbackComponent>
    );
  }
}

Callback.propTypes = {
  login: PropTypes.func.isRequired,
  error: PropTypes.func.isRequired,
};

export default Callback;
